const onDOMContentLoaded = require('../utilities/dom/onDOMContentLoaded');

const BASE_CONFIG = window.BASE_CONFIG;
const FLOATING_NAVIGATION_CLASS = 'floating-navigation'; // Used in the Home
const FLOATING_PLP_NAVIGATION_CLASS = 'floating-plp-navigation';
const STICKY_NAVIGATION_CLASS = 'sticky-floating-navigation';

const mql = window.matchMedia('(max-width: ' + (BASE_CONFIG.responsive.screen__1025 - 1) + 'px)');
const headerBanner = document.getElementsByClassName('header-banner')[0];
const header = document.getElementsByClassName('header')[0];
// Allow floating-plp-navigation to make old class compatible
const stickyNavigation = document.querySelector(
    `.${STICKY_NAVIGATION_CLASS}, .${FLOATING_PLP_NAVIGATION_CLASS}`
);
const floatingNavigation = document.getElementsByClassName(FLOATING_NAVIGATION_CLASS);

/**
 * Calculate the height and position of the Floating Navigations (her/him) based on the screen width and header height
 */
function setFloatingNavigationPosition() {
    if (!floatingNavigation || floatingNavigation.length === 0) {
        return;
    }
    if (!mql.matches) {
        var headerHeight = (headerBanner.offsetHeight || 0) + header.offsetHeight;
        for (var i = 0; i < floatingNavigation.length; i++) {
            floatingNavigation[i].style.top = headerHeight + 'px';
        }
    } else {
        for (var j = 0; j < floatingNavigation.length; j++) {
            floatingNavigation[j].style.top = 'inherit';
        }
    }
}

/**
 * Calculate the height and position of the PLP Navigation based on the screen width and header height
 */
function setFloatingPlpNavigationPosition() {
    if (!stickyNavigation) { return; }
    var headerHeight = (headerBanner.offsetHeight || 0)
        + header.offsetHeight;
    stickyNavigation.style.top = headerHeight + 'px';
}

/**
 * Removes transparent background
 */
function goSolid() {
    let blockClass = STICKY_NAVIGATION_CLASS;
    if (stickyNavigation.classList.contains(FLOATING_PLP_NAVIGATION_CLASS)) {
        blockClass = FLOATING_PLP_NAVIGATION_CLASS;
    }
    stickyNavigation.classList.remove(`${blockClass}--transparent`);
}

/**
 * Adds transparent background
 */
function goTransparent() {
    let blockClass = STICKY_NAVIGATION_CLASS;
    if (stickyNavigation.classList.contains(FLOATING_PLP_NAVIGATION_CLASS)) {
        blockClass = FLOATING_PLP_NAVIGATION_CLASS;
    }
    stickyNavigation.classList.add(`${blockClass}--transparent`);
}

onDOMContentLoaded(() => {
    if (stickyNavigation) {
        window.addEventListener('scroll', function () {
            if (this.oldScroll > this.scrollY) {
                goSolid();
            } else {
                goTransparent();
            }
            this.oldScroll = this.scrollY;
        });
    }
});

module.exports = {
    setFloatingNavigationPosition: setFloatingNavigationPosition,
    setFloatingPlpNavigationPosition: setFloatingPlpNavigationPosition
};
